import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../authentication/services/auth.guard.service';
import { SentimentFilterComponent } from './components/scripts/sentimentFilter.component';
import { SentimentComponent } from './components/scripts/sentiment.component';


const sentimentRoutes: Routes = [
 {
    path: 'sentiment', component: SentimentFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'SentimentManager']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: SentimentFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
  {
    path: 'sentiment/edit/:Id',
    component: SentimentComponent,
    data: {
      roles: ['Admin', 'SentimentManager']
    }
  },
  {
    path: 'sentiment/create',
    component: SentimentComponent,
    data: {
      roles: ['Admin', 'SentimentManager']
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(sentimentRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SentimentRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/sentiment/sentiment-routing.module.ts